import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { AbstractPane } from '@app/library/panes/models/abstract-pane';
import { TeacherCardModule } from '@app/teachers/teacher-card/teacher-card.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { User } from 'lingo2-models';
import { InViewportModule } from 'ng-in-viewport';

@Component({
  selector: 'app-teachers-column',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    LibraryElementsModule,
    TeacherCardModule,
    InViewportModule,
  ],
  templateUrl: './teachers-column.component.html',
  styleUrls: ['./teachers-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeachersColumnComponent extends AbstractPane {
  public trackUsersByFn(index: number, user: User): string {
    return user.id;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = !!this.users?.length;
  }

  public onInViewportBottomChange(reached) {
    if (reached.visible) {
      this.loadNextPage();
    }
  }
}
